import {Component, OnChanges, OnInit, SimpleChange, SimpleChanges} from '@angular/core';

import {MosaicHttp, NEMLibrary, NetworkTypes} from 'nem-library';

import { enableProdMode } from '@angular/core';

enableProdMode();

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})



export class AppComponent implements OnInit{
  myNamespace = 'dim';
  title = 'Namespace2Mosaic';
  mosaicDefinitions = [];
  mosaicHttp = new MosaicHttp([
    {protocol: 'https', domain: 'shibuya.supernode.me', port: 7891},
    {protocol: 'https', domain: 'nis2.wnsl.biz', port: 7779}
  ]);
  ngOnInit() {
    NEMLibrary.bootstrap(NetworkTypes.MAIN_NET);
  }
  show() {
    this.mosaicHttp.getAllMosaicsGivenNamespace(this.myNamespace).subscribe(mosaicDefinitions => {
      this.mosaicDefinitions = mosaicDefinitions;
      console.log(this.mosaicDefinitions);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts